import normalizeLanguageCode from './language.js';

export const sortDecksByPreferredLanguage = (deckList, preferredLanguage) => {
  if (!Array.isArray(deckList) || deckList.length === 0) {
    return [];
  }

  const normalizedPreferredLanguage = normalizeLanguageCode(preferredLanguage);
  const preferredDecks = [];
  const otherDecks = [];

  deckList.forEach((deck) => {
    const targetGroup = normalizeLanguageCode(deck?.language) === normalizedPreferredLanguage
      ? preferredDecks
      : otherDecks;
    targetGroup.push(deck);
  });

  return [...preferredDecks, ...otherDecks];
};
